const PATHS = {};

PATHS.LOGIN = "/login";
PATHS.HOME = "/user/showAccountLink";
PATHS.EXTERNAL_CONFIRM_LOGIN = "/authConfirm/:token";

PATHS.SHOW_ACCOUNT_LINK = "/user/showAccountLink";

PATHS.NEW_UPLOAD = "/adm/upload/new";

export default PATHS;
